
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/z-index.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_Page";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_Page__root","page":"wds_1_76_1_Page__page","scrollableContainer":"wds_1_76_1_Page__scrollableContainer","pageHeaderContainer":"wds_1_76_1_Page__pageHeaderContainer","headerWrapper":"wds_1_76_1_Page__headerWrapper","tail":"wds_1_76_1_Page__tail","contentContainer":"wds_1_76_1_Page__contentContainer","imageBackgroundContainer":"wds_1_76_1_Page__imageBackgroundContainer","imageBackground":"wds_1_76_1_Page__imageBackground","gradientBackground":"wds_1_76_1_Page__gradientBackground","contentHorizontalLayout":"wds_1_76_1_Page__contentHorizontalLayout","contentFloating":"wds_1_76_1_Page__contentFloating","horizontalScroll":"wds_1_76_1_Page__horizontalScroll","sticky":"wds_1_76_1_Page__sticky","stretchVertically":"wds_1_76_1_Page__stretchVertically","fixedFooter":"wds_1_76_1_Page__fixedFooter"};
export var keyframes = {"entrance":"wds_1_76_1_Page__entrance"}; 
export var layers = {};
export var containers = {};
export var stVars = {"pageSidePadding":"48px","headerBottomPadding":"24px","imageContainerOffset":"30px","pageBottomPadding":"48px","minimizedHeaderWrapperMinHeight":"30px","minimizedHeaderWrapperTopPadding":"18px","minimizedHeaderWrapperBottomPadding":"18px","minimizedHeaderWrapperWithTailBottomPadding":"12px","minimizedHeaderWrapperHeightPx":"66","minimizedHeaderWrapperWithTailHeightPx":"60","backgroundCoverContentPx":"36","zIndexLayerStep":"100","stickyZIndex":"1100","minimizedHeaderContainerZIndex":"1200","fixedFooterZIndex":"2000","mainContainerMinWidth":"864px","mainContainerMaxWidth":"1248px"}; 
export var vars = {"minimizationTop":"--wds_1_76_1_Page-minimizationTop"}; 




